// @ts-expect-error untyped import
import { handleActions } from 'flux-actions';
// @ts-expect-error untyped import
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
const initialState = null;
export default handleActions({
  [ActionTypes.COMPANY_NAME_FETCH_SUCCEEDED](info, action) {
    return action.payload;
  }
}, initialState);